interface AdminBarChartProps {
	data: number[];
	labels: string[];
	color?: string;
	height?: number;
}

export function AdminBarChart({
	data,
	labels,
	color = "var(--a-terracotta)",
	height = 160,
}: AdminBarChartProps) {
	const w = 600;
	const h = height;
	const padL = 32;
	const padR = 8;
	const padT = 8;
	const padB = 24;
	const innerW = w - padL - padR;
	const innerH = h - padT - padB;
	// Une série entièrement à zéro donnait une hauteur NaN pour chaque barre.
	const sommet = Math.max(0, ...data) * 1.15;
	const max = sommet > 0 ? sommet : 1;
	const bw = (innerW / data.length) * 0.6;
	const gap = (innerW / data.length) * 0.4;

	return (
		<svg
			viewBox={`0 0 ${w} ${h}`}
			style={{ width: "100%", height, display: "block" }}
		>
			{[0, 1, 2, 3, 4].map((i) => {
				const y = padT + (i / 4) * innerH;
				return (
					<line
						key={i}
						x1={padL}
						y1={y}
						x2={w - padR}
						y2={y}
						stroke="var(--a-border)"
						strokeDasharray={i === 4 ? "0" : "2 3"}
					/>
				);
			})}
			{data.map((v, i) => {
				const barH = (v / max) * innerH;
				const x = padL + i * (bw + gap) + gap / 2;
				const y = padT + innerH - barH;
				return (
					<g key={i}>
						<rect
							x={x}
							y={y}
							width={bw}
							height={barH}
							fill={color}
							opacity={i === data.length - 1 ? 1 : 0.55}
							rx="2"
						/>
						<text
							x={x + bw / 2}
							y={h - 8}
							textAnchor="middle"
							fontSize="10"
							fill="var(--a-ink-mute)"
						>
							{labels[i]}
						</text>
					</g>
				);
			})}
		</svg>
	);
}
